import './helpers.mjs';
import './config.mjs';
import { b as registerComponent, u as use } from './plugins-a4da84c4.mjs';
import './Icon-76d58102.mjs';
import './FormElementMixin-8424e4ab.mjs';
import './Input-84d6cd7d.mjs';
import './MatchMediaMixin-2d99700d.mjs';
import './trapFocus-21978f6e.mjs';
import './DropdownItem-79154d71.mjs';
import './Select-691e3e38.mjs';
import { _ as __vue_component__ } from './Datepicker-76e80fdb.mjs';
export { _ as ODatepicker } from './Datepicker-76e80fdb.mjs';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
